import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
	selector: 'ui-modal',
	template: `
		<div #modal class="modal ui-modal {{lg?'lg':''}} {{class?class:''}} {{isHidden?'modal-is-hidden':'modal-is-shown'}}"
			 (click)="handleClick($event)"
			 [hidden]="isHidden">
			<div class="modal-dialog modal-{{size}}" role="document">
				<div class="modal-content">
					<div class="modal-header" *ngIf="title || closeable">
						<h3 class="modal-title">{{title}}
							<button class="btn btn-dark btn-sm float-right" (click)="hide()"
									[hidden]="!closeable">close
							</button>
						</h3>
					</div>
					<div class="modal-body">
						<ng-content></ng-content>
					</div>
				</div>
			</div>
		</div>
	`
})

export class UIModalComponent {

	@Input() isHidden = true;
	@Input() lg = false;
	@Input() class = '';
	@Input() title = '';
	@Input() closeable = true;
	@Input() size = ''; // full lg sm
	@Output() isHiddenChange = new EventEmitter();
	@ViewChild('modal', {static: false}) modal;

	handleClick(e) {
		if (this.closeable) {
			if (e.target == this.modal.nativeElement) {
				this.hide();
			}
		}
	}


	show() {
		console.log('show modal');
		this.isHidden = false;
		this.isHiddenChange.emit(false);
	}

	hide() {
		if (this.closeable) {
			this.isHidden = true;
			this.isHiddenChange.emit(true);
		}
	}


}
